import { CustomerRole } from '../customer/customer.schema'
import { DevlopRole } from '../devlop/devlop.schema'
import { ProductionRole } from '../production-project/production.schema'

export const ProjectRole = {
  ...ProductionRole,
  ...DevlopRole,
  ...CustomerRole,
} as const
